var directive = function($parse) {
  return {
    scope: {
      sortable: '=',
      sortBy: '@',
      defaultDirection: '@?',
    },
    template: '<span><span ng-transclude class="cursor-pointer" ng-class="{w600: sortable.type == sortBy}"></span><arrow ng-if="sortable.type == sortBy" direction="{{sortable.direction}}" class="margin-left--smallest"></arrow></span>',
    transclude: true,
    link: function(scope, element, attrs) {
      element.bind('click', function($event) {
        scope.$apply(function () {
          if (!scope.sortable) {
            return;
          }
          if (scope.sortable.type == scope.sortBy) {
            scope.sortable.direction = scope.sortable.direction === 'ASC' ? 'DESC' : 'ASC';
          } else {
            scope.sortable.type = scope.sortBy;
            scope.sortable.direction = scope.defaultDirection ? scope.defaultDirection : 'ASC';
          }
          scope.sortable.sortCallBack({order: scope.sortable.type, direction: scope.sortable.direction});
        });
      });
    }
  };
};

directive.$inject = ['$parse'];

tiz.directive('sortable', directive);
